import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { DriverReviewLightBoxActions } from '../constants/driver_review_light_box/driver_review_light_box_actions';

class DriverReviewLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            obj: null,
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.DRIVER_REVIEW_LIGHTBOX_ACTION) {
            switch (action.type) {
                case DriverReviewLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        state.obj = action.payload;
                        this.__emitChange();
                    }

                    break;

                case DriverReviewLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const DriverReviewLightBoxStore = new DriverReviewLightBoxStoreClass(Dispatcher);
export { DriverReviewLightBoxStore };
